module.exports = __webpack_public_path__ + "img/daftar_booking.fb8d00a0.svg";